import type {AppDispatch, GetState} from '@/redux/typesNew';

import {isHotelKeyword, KeywordTypes} from '@/api/keywordApi';
import {fetchKeywordData} from '@/redux/v1/keywordData/actions';

export const resolveDestinationId = async (
  destinationId: string,
  dispatch: AppDispatch,
  getState: GetState
) => {
  /**
   * We don't request a list for just one hotel (it will be shown above the list seperately).
   * Instead we want to show a list with results from the hotels parent region.
   * So we need to resolve the keyword first (wait/waterfall)
   * @see https://invia.atlassian.net/browse/FFP-4286
   */
  if (isHotelKeyword(destinationId)) {
    const keyword = await fetchKeywordData(destinationId)(dispatch, getState);
    if (
      keyword?.data &&
      keyword.data.type === KeywordTypes.hotel &&
      keyword.data.meta?.parentId
    ) {
      return keyword.data.meta.parentId as string;
    }
  }
  return destinationId;
};
